import {RightOutlined} from '@ant-design/icons';
import cn from 'classnames';
import React, {FC} from 'react';

interface INewSideMenuExpandProps {
    onClick?: () => void;
    isOpen?: boolean;
}

export const NewSideMenuExpand: FC<INewSideMenuExpandProps> = (
    {onClick, isOpen}: INewSideMenuExpandProps,
) => (
    <div
        className={cn('new-side-menu__expand', {
            'new-side-menu__expand_open': isOpen,
        })}
        onClick={() => {
            onClick?.();
        }}
    >
        <RightOutlined />
    </div>
);
